function formatUnit(value: number, unit: 'day' | 'hour' | 'minute', locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'unit',
    unit,
    unitDisplay: 'short',
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatDurationFromHours(value: number | undefined, locale: string): string {
  if (value == null) {
    return '';
  }

  const totalMinutes = Math.round(value * 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return [formatUnit(hours, 'hour', locale), formatUnit(minutes, 'minute', locale)].join(' ');
}

export function formatDurationFromTicks(value: number, locale: string): string {
  const totalMinutes = Math.round(value / (60 * 10e6));
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;

  return [formatUnit(days, 'day', locale), formatUnit(hours, 'hour', locale), formatUnit(minutes, 'minute', locale)].join(' ');
}

export function formatDayCountFromTicks(value: number, locale: string): string {
  const days = Math.round(value * 1000 / (24 * 60 * 60 * 10e6)) / 1000;

  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 3,
  }).format(days);
}